import { createAction, props } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { ISearchEmployeeRequest, ISearchEmployeeResponse } from '../models/search-employees.model';

export const loadSearchEmployees = createAction('[SearchEmployees] Load SearchEmployees', props<{ request: ISearchEmployeeRequest }>());

export const loadSearchEmployeesSuccess = createAction(
  '[SearchEmployees] Load SearchEmployees Success',
  props<{ response: ISearchEmployeeResponse }>()
);

export const loadSearchEmployeesFailure = createAction(
  '[SearchEmployees] Load SearchEmployees Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
